/** @deprecated Import from `@cornerstonejs/metadata` instead. */
import { utilities } from '@cornerstonejs/metadata';

const { splitImageIdsBy4DTags, handleMultiframe4D, generateFrameImageId } =
  utilities;

export default splitImageIdsBy4DTags;
export { handleMultiframe4D, generateFrameImageId };
